<template>
  <div id="header2">
    <div class="header2">
      <div class="main">
        <a href="/" class="logo">
          <!-- <img :src="webIco" alt id="enterpriseLogo" /> -->
          <img :src="websiteInfo.headLogo" alt id="enterpriseLogo" />
          <p>
            <!-- <span v-if="enterpriseId == 113">京伦</span>
            <span v-if="enterpriseId == 135">当代</span>-->
            <!-- 在线教育培训平台 -->
            {{ websiteInfo.headTitle }}
          </p>
        </a>
        <!-- <div class="search">
          <input v-model="searchVal" placeholder="请输入关键词搜索" />
          <div class="btn"></div>
        </div>-->
        <div class="phone">
          <!-- <p class="number">{{ entpTel }}</p> -->
          <p class="number">{{ websiteInfo.headLinkTel }}</p>
          <!-- <p class="time">周一至周五:9:00-18:00</p> -->
        </div>
      </div>
      <div class="nav-bar" id="header2Nav">
        <div class="nav-content">
          <div class="nav-menu">
            <router-link to="/home">网站首页</router-link>
            <router-link
              to="/publicCourse"
              v-if="websiteInfo.navigateDir.publicCourseLib == 1"
            >公共课程库</router-link>
            <router-link
              to="/technical/training1"
              v-if="websiteInfo.navigateDir.trainIntroduce == 1"
            >培训介绍</router-link>
            <router-link
              to="/offlineCourseList"
              v-if="websiteInfo.navigateDir.offlineCourse == 1"
            >线下课程</router-link>
            <router-link to="/examList" v-if="websiteInfo.navigateDir.practiceCenter == 1">练习中心</router-link>
            <router-link to="/livePlayback" v-if="websiteInfo.navigateDir.live == 1">在线直播</router-link>
            <!-- <router-link to="/testList" v-if="showExam">考试中心</router-link> -->
            <router-link to="/testList" v-if="websiteInfo.navigateDir.examCenter == 1">考试中心</router-link>
            <router-link to="/news" v-if="websiteInfo.navigateDir.policyAdvice == 1">政策资讯</router-link>
            <router-link to="/service" v-if="websiteInfo.navigateDir.quickService == 1">快捷服务</router-link>
          </div>
          <div class="nav-login" @click="openLogin" v-if="!isLoginState">
            登录
            <!-- <div class="el-icon-mobile-phone" @mouseenter.stop="codeShow=true" @mouseleave="codeShow=false">
              <transition name="fade">
                <div class="wecode" v-show="codeShow">
                  <img :src="studyQrCode" alt="" v-if="studyQrCode">
                  <img src="../../static/qrcode.jpg"  v-else alt="">
                  <p>H5&微信</p>
                </div>
              </transition>
              
            </div>-->
          </div>
          <div
            class="nav-user"
            v-else
            style="position: relative; display: flex; align-items: center"
          >
            <template v-if="isLoginState">
              <span
                class="entBtn"
                icon="el-icon-s-tools"
                @click="gotoEnterpriseManagement"
              >{{ userType == "02"|| userType == "08" || userType == "09" ? "企业后台" : "" }}</span>
              <span
                class="entBtn"
                icon="el-icon-s-tools"
                @click="gotoEnterpriseManagement"
              >{{ userType == "05" ? "学习中心" : "" }}</span>
              <!-- <div style="width:1px;height:20px;background:#fff;margin-right:15px"></div> -->
              <div
                style="
                  width: 1px;
                  height: 20px;
                  background: #fff;
                  margin-right: 15px;
                "
              ></div>
            </template>
            <!-- <span
              class="entBtn"
              v-if="showMangement && isLogin"
              icon="el-icon-s-tools"
              @click="gotoEnterpriseManagement"
              >企业后台</span
            >-->
            <el-dropdown @command="handleCommand" style="display: flex; align-items: center">
              <span class="el-dropdown-link" style="display: flex; align-items: center">
                <!-- <el-avatar> {{ empName }} </el-avatar> -->
                <img :src="avatar" alt style="width: 40px; height: 40px" />
                <span class="ename" :title="nickName">
                  {{ nickName }}
                  <i class="el-icon-caret-bottom"></i>
                </span>
              </span>

              <el-dropdown-menu slot="dropdown" class="el-dropdown">
                <!-- <el-dropdown-item command="gotoEnterpriseManagement" v-if="showMangement && isLogin" icon="el-icon-s-tools">企业后台</el-dropdown-item> -->
                <!-- <el-dropdown-item command="goStudy" v-if="userType =='05'">
                  <div class="drop-item">
                    <i class="el-icon-video-camera"></i>
                    学习中心
                  </div>
                </el-dropdown-item>-->
                <el-dropdown-item command="goUser">
                  <div class="drop-item">
                    <i class="el-icon-user"></i>
                    个人中心
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="logoOut">
                  <div class="drop-item">
                    <i class="el-icon-circle-close"></i>
                    退出登录
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <router-link to="/notice" v-if="isLoginState" class="relative">
              <el-badge :value="unReadNotice" class="item" :hidden="unReadNotice <= 0">
                <img src="../../static/noticeNew.png" alt />
              </el-badge>
              <!-- <div class="dotIcon" v-if="unReadNotice>0">
                {{unReadNotice}}
              </div>-->
            </router-link>
            <!-- <div
              class="el-icon-mobile-phone"
              @mouseenter.stop="codeShow=true"
              @mouseleave="codeShow=false"
            >
              <transition name="fade">
                <div class="wecode" v-show="codeShow">
                  <img :src="studyQrCode" alt v-if="studyQrCode" />
                  <img src="../../static/qrcode.jpg" v-else alt />
                  <p>H5&微信</p>
                </div>
              </transition>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告 -->
    <notice-Box></notice-Box>

     <!-- 公众号弹窗 -->
      <!-- <el-dialog
      title="重要提示"
      :visible.sync="dialogVisibleAccount"
      width="468px"
      :before-close="closeAccount"
      :close-on-click-modal="false">
      <p style="text-align:center;margin-bottom:27px;">
        <img src="../../static/accountCode.png" />
      </p>
      <p style="text-align:center;font-size:16px;">请前往微信公众号 在线学习</p>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="closeAccount">确 认</el-button>
      </div>
      </el-dialog> -->

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getBizListByPost,
  getBizList,
  getCmsList,
  getLatestNotice,
  getCourseList
} from "@/api/service.js";

import {
  getNoticeLittleRedCount,
  getEntpOtherConfig,
  getEntpConfigDefault
} from "@/apiCloud/common.js";


import { getToken } from "@/utilsCloud/auth";
import { localURL } from "@/api/baseURL.js";
import QRCode from "qrcode";
import { pUrl } from "@/api/baseURL.js";
import { eUrl } from "@/api/baseURL.js";

import noticeBox from "./noticeBox/noticeBox.vue";

let that;
export default {
  components: {
    noticeBox
  },
  name: "header2",
  data() {
    return {
      // entpId:"",
      eHost: "",
      // searchVal: "",
      // empHeadportrait: "",
      // empName: "", //姓名
      // showMangement: false, //是否有权限进入企业后台
      isLogin: false,
      // company_phone: "",
      codeShow: false,
      unReadNotice: 0,
      showExam: false,
      tokenId: "",
      dialogVisibleAccount:false, //公众号二维码弹窗,
      training:''
    };
  },
  computed: {
    ...mapGetters([
      "enterpriseId",
      "webIeIco",
      "webIco",
      "entpTel",
      "isLoginState",
      "avatar",
      "nickName",
      "isEnterPrise",
      "empNameState",
      "userType",
      "studyQrCode",
      "websiteInfo"
    ])
  },
  created() {
    this.eHost = window.location.host;
    that = this;
    this.tokenId = getToken();
    if (this.tokenId != null) {
      this.getNoticeLittleRedCount();
      if(sessionStorage.getItem('dialogVisibleAccount') == 'true'){
        this.dialogVisibleAccount = false;
      }else{
        this.dialogVisibleAccount = true;
      }
    }

    if (this.tokenId != null && this.userType == "01") {
      var eUrl = window.location.href;
      window.location.replace(
        eUrl.substring(0, eUrl.indexOf("/", 8)) + "/admin/index"
      );
    }
  },
  mounted() {
    this.getOtherConfig();
    this.getEntpConfig()
  },
  methods: {
    //获取培训类型配置
    getEntpConfig(){
      let data ={
        entpId:localStorage.getItem("enterpriseId")
      }
      getEntpConfigDefault(data).then(res =>{
        if(res.code == 200){
          this.training = res.data.training
          localStorage.setItem('training',this.training)
        }
      })   
    },
    //关闭二维码弹窗
    closeAccount(){
      this.dialogVisibleAccount = false
      sessionStorage.setItem('dialogVisibleAccount',true);
    },
    //获取当前企业配置信息
    getOtherConfig() {
      let data = {};
      getEntpOtherConfig(data).then(res => {
        this.$store.commit('SET_OTHER_CONFIG',res.data)
        localStorage.setItem("otherConfig_showExam", res.data.showExam);
        this.visitorMode = res.data.visitorMode;
        this.showExam = res.data.showExam == 0 ? true : false;
        this.showStudyQrCode = res.data.showQrCode == 0 ? true : false;
        this.showExam =
          localStorage.getItem("otherConfig_showExam") == 0 ? true : false;
        if (res.data.visitorMode == 1) {
          if (!getToken()) {
            that.$router.push({
              path: "/login"
            });
          }
        }
      });
      // }
      //  else {
      //   this.showExam =
      //     localStorage.getItem("otherConfig_showExam") == 0 ? true : false;
      // }
    },
    //   个人中心下拉点击
    handleCommand(command) {
      this[command]();
    },
    goStudy() {
      if (this.$route.path == "/StudyCentre") {
        return;
      }
      this.$router.push({
        path: "/StudyCentre"
      });
    },
    goUser() {
      this.$router.push({
        path: "/userCenter"
      });
    },
    openLogin() {
      this.$loginBox();
    },

    //消息是否有未读
    getNoticeLittleRedCount() {
      getNoticeLittleRedCount().then(res => {
        if (res.code == 200) {
          // if (res.data > 0) {
          //   this.unReadNotice = 1;
          // } else {
          //   this.unReadNotice = 0;
          // }
          this.unReadNotice = res.data;
        }
      });
    },
    //退出登录
    logoOut() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            localStorage.clear();
            sessionStorage.clear();
            this.$router.push("/home");
            setTimeout(() => {
              this.$router.go(0);
            }, 1000);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消退出登录"
          });
        });
    },
    //后台
    gotoEnterpriseManagement() {
      if (this.userType == "05") {
        this.goStudy();
        return;
      }
      var eUrl = window.location.href;
      sessionStorage.setItem("userObj", localStorage.getItem("userObj"));
      console.log(eUrl.substring(0, eUrl.indexOf("/", 14)) + "/admin/index");
      window.open(eUrl.substring(0, eUrl.indexOf("/", 8)) + "/admin/index");
    }
  }
};
</script>

<style lang="less">
#app #header2 + div {
  margin-top: 20px;
}
#app #header2.fix + .first-screen {
  .cate-part {
    top: 60px;
  }
}
</style>
<style scoped lang="less">
.header2 {
  background: url(../../static/home2.0/header-bg.png) no-repeat center -1px;
  width: 100%;
  // position: fixed;
  // z-index: 999;
  // top: 0;
  // left: 0;
  .main {
    width: 1200px;
    margin: 0 auto;
    height: 99px;
    background: url(../../static/home2.0/header-bg.png) no-repeat center -1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: flex;
      height: 100%;
      align-items: center;
      img {
        display: block;
        max-height: 50%;
      }
      p {
        position: relative;
        display: flex;
        color: #666;
        font-size: 20px;
        margin-left: 21px;
        // font-family: ycy;
        transition: all 0.3s;
      }
      &:hover p {
        color: #3482ff;
      }
    }
    .search {
      position: relative;
      width: 410px;
      height: 40px;
      background: #3482ff;
      padding: 2px;
      box-sizing: border-box;
      input {
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 0;
        border: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #666;
        display: inline-block;
        font-size: inherit;
        height: 36px;
        line-height: 36px;
        outline: 0;
        padding: 0 12px;
        -webkit-transition: border-color 0.2s
          cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
      }
      .btn {
        position: absolute;
        width: 52px;
        height: 40px;
        right: 0;
        top: 0;
        // background: #3482FF url(../../static/home2.0/icon-search.png)
        // no-repeat center;
        cursor: pointer;
      }
    }
    .phone {
      background: url(../../static/home2.0/icon-phone.png) no-repeat center left;
      padding-left: 54px;
      height: 41px;
      .number {
        font-size: 20px;
        color: #3482ff;
        line-height: 2;
      }
      .time {
        color: #666666;
        font-size: 14px;
        line-height: 1;
        margin-top: 5px;
      }
    }
  }
  .nav-bar {
    height: 60px;
    width: 100%;
    background: #3482ff;
    &.fixed {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
    }
    .nav-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .nav-menu {
        display: flex;
        width: 960px;
        height: 100%;
        // margin-left: 53px;
        align-items: center;
        // justify-content: space-between;
        a {
          color: #fff;
          font-size: 18px;
          &.router-link-active {
            border-bottom: 2px solid #fff;
          }
          &:not(:first-child) {
            margin-left: 35px;
          }
        }
      }
      .nav-login {
        font-size: 16px;
        height: 60px;
        line-height: 60px;
        color: #fff;
        background: url(../../static/home2.0/icon-me.png) no-repeat center left;
        padding-left: 20px;
        cursor: pointer;
      }
      .el-icon-mobile-phone {
        font-size: 21px;
        padding-left: 10px;
        position: relative;
        line-height: 60px;
        top: 2px;
        color: #fff;
        .wecode {
          position: absolute;
          background: #fff;
          border-radius: 0 0 4px 4px;
          box-shadow: 0 0 10px 0px #666;
          width: 250px;
          height: 250px;
          left: -119px;
          top: 58px;
          z-index: 60;
          overflow: hidden;
          z-index: 70;
          img {
            position: absolute;
            width: 150px;
            top: 50%;
            left: 50%;
            margin-top: -95px;
            margin-left: -75px;
          }
          p {
            position: absolute;
            bottom: 10px;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #999;
          }
        }
      }
      .nav-user {
        cursor: pointer;
        .entBtn {
          position: relative;
          color: #fff;
          font-size: 16px;
          padding-right: 5px;
        }
        .ename {
          display: inline-block;
          max-width: 65px;
          height: 40px;
          line-height: 40px;
          color: #fff;
          font-size: 14px;
          top: 0;
          left: 45px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 16px;
          box-sizing: border-box;
          margin-left: 10px;
          i {
            position: absolute;
            right: 0;
            line-height: 40px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .dotIcon {
    position: absolute;
  }
  .el-badge {
    /deep/ .el-badge__content {
      box-sizing: content-box;
      padding: 0 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue